import { WeeklyIncomePreference } from './WeeklyIncomeSettings';
import React, { useState } from "react";
import Layout from "../Layout/Layout";
import {
    FaFirstOrder, FaUserAlt, FaSellcast, FaLanguage, FaMapMarkerAlt,
    FaWallet, FaAddressCard, FaUserCog, FaUserSecret, FaMoneyBill,
    FaIdeal, FaSlidersH, FaBuysellads, FaPhoneAlt, FaStore, FaChartLine,
    FaCrown, FaUsers, FaHandshake, FaGlobe, FaTools, FaTruck, FaRoute, FaBriefcase, FaRobot,
    FaHeartbeat, FaShieldAlt, FaImages, FaExchangeAlt, FaUserShield
} from "react-icons/fa";
import {
    MdPublic, MdLanguage, MdCreateNewFolder, MdAddBusiness,
    MdAlternateEmail, MdDashboard, MdTrendingUp, MdCheckBox, MdIndeterminateCheckBox, MdSecurity,
    MdMarkEmailRead, MdDeleteForever
} from "react-icons/md";
import { AiFillShop } from "react-icons/ai";
import { GrAscend, GrBusinessService, GrSettingsOption } from "react-icons/gr";
import { GiSellCard, GiChessKing, GiFamilyTree } from "react-icons/gi";
import { RiUserCommunityFill } from "react-icons/ri";
import Table from 'react-bootstrap/Table';
import { Row } from 'react-bootstrap';
import { Link } from "react-router-dom";
import { Family, Adminstrator, Investment, Assoociate, Provider, Seller, CommercialRole, isSwitchRoleAvailable, isProviderOnlyWorkspace } from "../pageInside/Rolle";
import { buildProviderWorkspace } from "../dropshippingInterne/providerWorkspace";
import { buildSellerSettingsNav } from "../Layout/myBusinessNav";
import { laguangeElakay } from "../pageInside/dataElakay";
import { elakayAutoText } from "../pageInside/dataElakay";
import { isAuthenticated } from "../auth";
import LocalSellingModal from "../pageInside/LocalSellingModal";
import RoleSwitchDropdown from "../../components/RoleSwitch/RoleSwitchDropdown";
import { canAccessSwiperManager, useSwiperAccess } from "../dynamicSwipers/useSwiperAccess";
import useEmailMarketingPermissions from "../pageInside/EmailMarketing/useEmailMarketingPermissions";
import { canSeePermissionCenterLink } from "../permissionCenter/pageAccess";
import AdditionalPageAccess from "../permissionCenter/AdditionalPageAccess";


const UserSerting = (props) => {
    const { infoSource } = props;
    const isCommercialRole = CommercialRole();
    const emailMarketing = useEmailMarketingPermissions({ enabled: isCommercialRole });
    const [showLocalSelling, setShowLocalSelling] = useState(false);
    const { token } = isAuthenticated() || {};
    const { loading: swiperAccessLoading, access: swiperAccess } = useSwiperAccess(infoSource);
    const canOpenSwiperManager = !swiperAccessLoading && canAccessSwiperManager(swiperAccess);

    let styleText = { fontSize: 'clamp(0.8rem, 2.5vw, 1.2rem)', margin: 0 };
    let userInfo = [];
    userInfo = infoSource.userInfo;

    let colClass = "col p-1";

    // Styles CSS Premium
    const premiumStyles = `
/* ===== ANIMATIONS PREMIUM ===== */
@keyframes elegantPageEnter {
    from {
        opacity: 0;
        transform: translateY(40px) scale(0.96);
    }
    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

@keyframes elegantCardFloat {
    from {
        opacity: 0;
        transform: translateY(30px) rotateX(10deg);
    }
    to {
        opacity: 1;
        transform: translateY(0) rotateX(0deg);
    }
}

@keyframes shimmerGlow {
    0% {
        background-position: -1000px 0;
    }
    100% {
        background-position: 1000px 0;
    }
}

@keyframes iconFloat {
    0%, 100% {
        transform: translateY(0) scale(1);
    }
    50% {
        transform: translateY(-5px) scale(1.05);
    }
}

@keyframes gradientRotate {
    0% {
        background-position: 0% 50%;
    }
    50% {
        background-position: 100% 50%;
    }
    100% {
        background-position: 0% 50%;
    }
}

@keyframes pulseGlow {
    0%, 100% {
        box-shadow: 0 0 0 0 rgba(0, 164, 216, 0.5);
    }
    50% {
        box-shadow: 0 0 0 20px rgba(0, 164, 216, 0);
    }
}

/* Page container */
.user-setting-premium-page {
    animation: elegantPageEnter 0.8s cubic-bezier(0.34, 1.56, 0.64, 1) both;
}

/* Cards stagger */
.col.p-1 {
    animation: elegantCardFloat 0.7s cubic-bezier(0.34, 1.56, 0.64, 1) both;
}

.col.p-1:nth-child(1) { animation-delay: 0.05s; }
.col.p-1:nth-child(2) { animation-delay: 0.1s; }
.col.p-1:nth-child(3) { animation-delay: 0.15s; }
.col.p-1:nth-child(4) { animation-delay: 0.2s; }
.col.p-1:nth-child(5) { animation-delay: 0.25s; }
.col.p-1:nth-child(6) { animation-delay: 0.3s; }
.col.p-1:nth-child(7) { animation-delay: 0.35s; }
.col.p-1:nth-child(8) { animation-delay: 0.4s; }
.col.p-1:nth-child(9) { animation-delay: 0.45s; }
.col.p-1:nth-child(10) { animation-delay: 0.5s; }
.col.p-1:nth-child(11) { animation-delay: 0.55s; }
.col.p-1:nth-child(12) { animation-delay: 0.6s; }

/* ===== INFO USER SECTION ===== */

/* Container info user */
.row.mt-4.mb-4.justify-content-center:first-child .col[style*="border: 1px solid Gainsboro"] {
    border-radius: 24px !important;
    background: 
        linear-gradient(135deg, 
            rgba(255, 255, 255, 0.95) 0%, 
            rgba(248, 250, 252, 0.98) 100%
        ) !important;
    backdrop-filter: blur(20px);
    box-shadow: 
        0 20px 60px rgba(0, 115, 153, 0.15),
        0 0 0 1px rgba(255, 255, 255, 0.8),
        inset 0 1px 0 rgba(255, 255, 255, 0.6) !important;
    border: 1px solid rgba(226, 232, 240, 0.8) !important;
    overflow: hidden;
    position: relative;
}

/* Header info user */
.row.mt-4.mb-4.justify-content-center:first-child .col.col-12.col-md-12[style*="backgroundColor: WhiteSmoke"] {
    background: 
        linear-gradient(135deg, 
            rgba(0, 115, 153, 0.1) 0%, 
            rgba(0, 164, 216, 0.08) 100%
        ),
        linear-gradient(180deg, 
            rgba(255, 255, 255, 0.9) 0%, 
            rgba(248, 250, 252, 0.95) 100%
        ) !important;
    border-bottom: 2px solid transparent !important;
    border-image: linear-gradient(90deg, 
        transparent 0%, 
        rgba(0, 164, 216, 0.4) 50%,
        transparent 100%
    ) 1 !important;
    padding: 2rem 1rem !important;
    position: relative;
}

.row.mt-4.mb-4.justify-content-center:first-child .col.col-12.col-md-12[style*="backgroundColor: WhiteSmoke"] h3 {
    background: linear-gradient(135deg, 
        #006b8a 0%, 
        #007399 25%,
        #00a4d8 50%,
        #007399 75%,
        #006b8a 100%
    );
    background-size: 200% auto;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    font-weight: 800;
    margin: 0;
    letter-spacing: -0.02em;
    animation: shimmerGlow 3s linear infinite;
}

/* Table styling */
.row.mt-4.mb-4.justify-content-center:first-child table {
    margin-bottom: 0;
}

.row.mt-4.mb-4.justify-content-center:first-child table td {
    border: none;
    padding: 1rem 0.5rem;
    border-bottom: 1px solid rgba(226, 232, 240, 0.5);
}

.row.mt-4.mb-4.justify-content-center:first-child table tr:last-child td {
    border-bottom: none;
}

.row.mt-4.mb-4.justify-content-center:first-child table h4,
.row.mt-4.mb-4.justify-content-center:first-child table h5 {
    display: flex;
    align-items: center;
    gap: 1rem;
    color: #1e293b;
    font-weight: 600;
    margin: 0;
}

.row.mt-4.mb-4.justify-content-center:first-child table span[style*="fontSize: 30px"] {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    height: 50px;
    background: linear-gradient(135deg, #e0f2fe 0%, #dbeafe 100%);
    border-radius: 12px;
    color: #007399;
    box-shadow: 0 4px 12px rgba(0, 115, 153, 0.15);
    transition: all 0.3s ease;
}

.row.mt-4.mb-4.justify-content-center:first-child table tr:hover span[style*="fontSize: 30px"] {
    transform: scale(1.1) rotate(5deg);
    box-shadow: 0 6px 20px rgba(0, 115, 153, 0.25);
}

/* Role badges */
.row.mt-4.mb-4.justify-content-center:first-child .col.col-12.col-md-12[style*="backgroundColor: WhiteSmoke"] h3 span,
.row.mt-4.mb-4.justify-content-center:first-child .col.col-12.col-md-12[style*="backgroundColor: WhiteSmoke"] h3 h4 {
    display: inline-block;
    background: linear-gradient(135deg, #38bdf8 0%, #0ea5e9 100%);
    color: #ffffff;
    padding: 0.35rem 1rem;
    border-radius: 20px;
    font-size: 0.875rem;
    font-weight: 600;
    margin-left: 0.5rem;
    box-shadow: 0 4px 12px rgba(56, 189, 248, 0.3);
    animation: iconFloat 2s ease-in-out infinite;
}

/* ===== MENU SECTION ===== */

/* Container menu */
.row.mt-4.mb-4.justify-content-center:last-child .container[style*="border: 1px solid Gainsboro"] {
    border-radius: 24px !important;
    background: 
        linear-gradient(135deg, 
            rgba(255, 255, 255, 0.95) 0%, 
            rgba(248, 250, 252, 0.98) 100%
        ) !important;
    backdrop-filter: blur(20px);
    box-shadow: 
        0 20px 60px rgba(0, 115, 153, 0.15),
        0 0 0 1px rgba(255, 255, 255, 0.8),
        inset 0 1px 0 rgba(255, 255, 255, 0.6) !important;
    border: 1px solid rgba(226, 232, 240, 0.8) !important;
    overflow: hidden;
    position: relative;
}

/* Effet shimmer background */
.row.mt-4.mb-4.justify-content-center:last-child .container[style*="border: 1px solid Gainsboro"]::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(
        circle at center,
        rgba(0, 164, 216, 0.06) 0%,
        transparent 60%
    );
    animation: shimmerGlow 10s linear infinite;
    pointer-events: none;
    z-index: 0;
}

.row.mt-4.mb-4.justify-content-center:last-child .container[style*="border: 1px solid Gainsboro"] > * {
    position: relative;
    z-index: 1;
}

/* Header menu */
.row.mt-4.mb-4.justify-content-center:last-child .col.col-12.col-md-12[style*="backgroundColor: WhiteSmoke"] {
    background: 
        linear-gradient(135deg, 
            rgba(0, 115, 153, 0.1) 0%, 
            rgba(0, 164, 216, 0.08) 100%
        ),
        linear-gradient(180deg, 
            rgba(255, 255, 255, 0.9) 0%, 
            rgba(248, 250, 252, 0.95) 100%
        ) !important;
    border-bottom: 2px solid transparent !important;
    border-image: linear-gradient(90deg, 
        transparent 0%, 
        rgba(0, 164, 216, 0.4) 50%,
        transparent 100%
    ) 1 !important;
    padding: 2rem 1rem !important;
}

.row.mt-4.mb-4.justify-content-center:last-child .col.col-12.col-md-12[style*="backgroundColor: WhiteSmoke"] h3 {
    background: linear-gradient(135deg, 
        #006b8a 0%, 
        #007399 25%,
        #00a4d8 50%,
        #007399 75%,
        #006b8a 100%
    );
    background-size: 200% auto;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    font-weight: 800;
    margin: 0;
    animation: shimmerGlow 3s linear infinite;
}

/* ===== MENU CARDS ULTRA PREMIUM ===== */

.col.p-1 .card {
    border-radius: 20px;
    background: 
        linear-gradient(135deg, 
            rgba(255, 255, 255, 0.98) 0%, 
            rgba(248, 250, 252, 0.95) 100%
        );
    backdrop-filter: blur(10px);
    border: 1px solid rgba(226, 232, 240, 0.6);
    overflow: hidden;
    transition: all 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
    box-shadow: 
        0 4px 16px rgba(0, 115, 153, 0.08),
        0 0 0 1px rgba(255, 255, 255, 0.5),
        inset 0 1px 0 rgba(255, 255, 255, 0.8);
    position: relative;
    cursor: pointer;
}

.col.p-1 .card::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, 
        rgba(0, 164, 216, 0.05) 0%, 
        transparent 50%
    );
    opacity: 0;
    transition: opacity 0.5s ease;
    pointer-events: none;
}

.col.p-1 .card:hover {
    transform: translateY(-12px) scale(1.05) rotateX(3deg);
    box-shadow: 
        0 30px 60px rgba(0, 115, 153, 0.3),
        0 0 0 1px rgba(0, 164, 216, 0.4),
        0 0 80px rgba(0, 164, 216, 0.2),
        inset 0 1px 0 rgba(255, 255, 255, 0.9);
    border-color: rgba(0, 164, 216, 0.5);
}

.col.p-1 .card:hover::before {
    opacity: 1;
}

/* Pulse effect ultra premium */
.col.p-1 .card:hover::after {
    content: '';
    position: absolute;
    inset: -3px;
    border-radius: 20px;
    border: 3px solid rgba(0, 164, 216, 0.6);
    animation: pulseGlow 2s ease-in-out infinite;
    pointer-events: none;
}

/* Card body */
.col.p-1 .card-body {
    padding: 2.5rem 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: 
        radial-gradient(
            circle at center,
            rgba(0, 164, 216, 0.08) 0%,
            transparent 70%
        );
    position: relative;
}

/* Icon container premium */
.col.p-1 .card-body span.card-title {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 90px;
    height: 90px;
    background: 
        linear-gradient(135deg, 
            rgba(224, 242, 254, 0.95) 0%, 
            rgba(219, 234, 254, 0.9) 100%
        );
    backdrop-filter: blur(10px);
    border-radius: 20px;
    color: #007399;
    transition: all 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
    box-shadow: 
        0 8px 24px rgba(0, 115, 153, 0.2),
        inset 0 1px 0 rgba(255, 255, 255, 0.8);
    border: 1px solid rgba(0, 164, 216, 0.2);
    position: relative;
    overflow: hidden;
}

.col.p-1 .card-body span.card-title::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, 
        rgba(255, 255, 255, 0.4) 0%, 
        transparent 100%
    );
    opacity: 0;
    transition: opacity 0.5s ease;
}

.col.p-1 .card:hover .card-body span.card-title {
    transform: scale(1.2) rotate(10deg);
    background: 
        linear-gradient(135deg, 
            #00a4d8 0%, 
            #007399 100%
        );
    color: #ffffff;
    box-shadow: 
        0 15px 40px rgba(0, 164, 216, 0.4),
        inset 0 1px 0 rgba(255, 255, 255, 0.3);
    animation: iconFloat 1s ease-in-out infinite;
}

.col.p-1 .card:hover .card-body span.card-title::before {
    opacity: 1;
}

/* Footer */
.col.p-1 .card-footer {
    background: 
        linear-gradient(135deg, 
            rgba(255, 255, 255, 0.95) 0%, 
            rgba(248, 250, 252, 0.9) 100%
        );
    backdrop-filter: blur(10px);
    border-top: 1px solid rgba(226, 232, 240, 0.6);
    padding: 1rem;
    min-height: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.5s ease;
    font-weight: 600;
    color: #1e293b;
    letter-spacing: -0.01em;
}

.col.p-1 .card:hover .card-footer {
    background: 
        linear-gradient(135deg, 
            rgba(224, 242, 254, 0.95) 0%, 
            rgba(219, 234, 254, 0.9) 100%
        );
    color: #007399;
    transform: translateY(-2px);
}

/* ===== GROUPES DE MENU ===== */
.settings-group {
    margin-bottom: 1.75rem;
}

.settings-group:last-child {
    margin-bottom: 0;
}

.settings-group-title {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin: 0 0 0.75rem;
    padding: 0 0.25rem;
    font-size: 0.95rem;
    font-weight: 700;
    letter-spacing: 0.02em;
    color: #007399;
    text-transform: uppercase;
}

.role-switch-settings-group .role-switch-dropdown--list {
    max-width: 320px;
}

.settings-group-title::after {
    content: '';
    flex: 1;
    height: 2px;
    background: linear-gradient(90deg, rgba(0, 164, 216, 0.35) 0%, transparent 100%);
    border-radius: 2px;
}

.settings-group-description {
    margin: -0.25rem 0 1rem 0.25rem;
    color: #64748b;
    font-size: 0.9rem;
    line-height: 1.5;
}

.role-switch-settings-group {
    margin-top: 1rem;
    padding: 1rem;
    border: 1px solid rgba(148, 163, 184, 0.2);
    border-radius: 18px;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.9), rgba(240, 249, 255, 0.58));
    box-shadow: 0 8px 22px rgba(0, 115, 153, 0.07);
}

/* ===== RESPONSIVE ===== */
@media (max-width: 768px) {
    .row.mt-4.mb-4.justify-content-center .col[style*="border"],
    .row.mt-4.mb-4.justify-content-center .container[style*="border"] {
        border-radius: 20px !important;
    }

    .col.p-1 .card {
        border-radius: 16px;
    }

    .col.p-1 .card-body {
        padding: 2rem 1rem;
    }

    .col.p-1 .card-body span.card-title {
        width: 70px;
        height: 70px;
        font-size: 40px !important;
        border-radius: 16px;
    }

    .col.p-1 .card-footer {
        min-height: 60px;
        font-size: 0.875rem;
    }

    .role-switch-settings-group {
        padding: 0.8rem;
        border-radius: 15px;
    }
}

/* ===== REDUCED MOTION ===== */
@media (prefers-reduced-motion: reduce) {
    .user-setting-premium-page,
    .col.p-1,
    .col.p-1 .card,
    .col.p-1 .card-body span.card-title,
    .row.mt-4.mb-4.justify-content-center:first-child .col.col-12.col-md-12[style*="backgroundColor: WhiteSmoke"] h3,
    .row.mt-4.mb-4.justify-content-center:last-child .col.col-12.col-md-12[style*="backgroundColor: WhiteSmoke"] h3 {
        animation: none !important;
        transition: none !important;
    }
}
`;

    const roleUser = () => (
        <>
            {Seller(true) && (
                <span>{infoSource.laguangeElakay('title', infoSource.languageAPI).seller}</span>
            )}
            {Provider(true) && (
                <h4>{infoSource.laguangeElakay('title', infoSource.languageAPI).provider}</h4>
            )}
            {Assoociate(true) && (
                <span>{infoSource.laguangeElakay('title', infoSource.languageAPI).assoociate}</span>
            )}
            {Investment(true) && (
                <span>{infoSource.laguangeElakay('title', infoSource.languageAPI).investment}</span>
            )}
            {Adminstrator(true) && (
                <span>{infoSource.laguangeElakay('title', infoSource.languageAPI).Admin}</span>
            )}
            {Family() && (
                <span>{infoSource.laguangeElakay('title', infoSource.languageAPI).family}</span>
            )}
        </>
    );

    let telephone = infoSource.phoneUser && infoSource.phoneUser.filter(k => k.default === true)[0];
    let AddressTrue = infoSource.address && infoSource.address.filter(k => k.addressDefault === true)[0];

    const infoUser = (
        <div className="row mt-4 mb-4 justify-content-center">
            <style>{premiumStyles}</style>
            <div className="col col-12 col-md-10 col-lg-8 col-xl-6 p-0" style={{ border: "1px solid Gainsboro" }}>
                <div className="col col-12 col-md-12" style={{ textAlign: "center", backgroundColor: "WhiteSmoke" }}>
                    <h3>{infoSource.laguangeElakay('title', infoSource.languageAPI).yourInfo} {roleUser()}</h3>
                </div>
                <div className="m-3">
                    <Table>
                        <tbody>
                            <tr>
                                <td>
                                    <h4>
                                        <span style={{ fontSize: "30px", paddingRight: "20px" }}>
                                            <FaUserAlt />
                                        </span>
                                        {`${userInfo.firstname} ${userInfo.lastname}`}
                                    </h4>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <h5>
                                        <span style={{ fontSize: "30px", paddingRight: "20px" }}>
                                            <MdAlternateEmail />
                                        </span>
                                        {userInfo.email}
                                    </h5>
                                </td>
                            </tr>
                            {telephone && (
                                <tr>
                                    <td>
                                        <div>
                                            <h5>
                                                <span style={{ fontSize: "30px", paddingRight: "20px" }}>
                                                    <FaPhoneAlt />
                                                </span>
                                                {telephone.International}
                                            </h5>
                                        </div>
                                    </td>
                                </tr>
                            )}
                            {AddressTrue && (
                                <tr>
                                    <td>
                                        <h5>
                                            <span style={{ fontSize: "30px", paddingRight: "20px" }}>
                                                <FaMapMarkerAlt />
                                            </span>
                                            <span>
                                                {AddressTrue.firstName} {AddressTrue.lastName}
                                                <br />
                                                <span style={{ paddingLeft: "20px" }}>
                                                    {AddressTrue.Address1}, {AddressTrue.city} {AddressTrue.State} {AddressTrue.postalCode} {AddressTrue.country}
                                                </span>
                                                <br />
                                                <span style={{ paddingLeft: "21px", fontSize: "14px" }}>
                                                    {infoSource.laguangeElakay('title', infoSource.languageAPI).defaultDeliryAdress}
                                                </span>
                                            </span>
                                        </h5>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </div>
            </div>
        </div>
    );

    const isAssoc = Assoociate();
    const isInvest = Investment();
    const isAdmin = Adminstrator();
    const isFam = Family();
    const showAddRoleGroup = isAssoc || isInvest || isAdmin || isFam;
    const showJobGroup = isFam || isAdmin;
        const showDashboardSettingsGroup = isFam || isAdmin || canOpenSwiperManager;

    const providerOnly = isProviderOnlyWorkspace(infoSource);
    const providerItems = buildProviderWorkspace(infoSource);
    // Seller Dropshipping In + External Dropshipping -- the same gated lists as
    // the account menu (myBusinessNav.js).
    const sellerGroups = buildSellerSettingsNav(infoSource);

    const menu = (
        <div className="row mt-4 mb-4 justify-content-center user-setting-premium-page">
            <div className="container p-0" style={{ border: "1px solid Gainsboro" }}>
                <div className="col col-12 col-md-12" style={{ textAlign: "center", backgroundColor: "WhiteSmoke" }}>
                    <h3>{infoSource.laguangeElakay('title', infoSource.languageAPI).menu}</h3>
                </div>
                <div className="container-fluid">

                    {/* Individual grants belong only to this signed-in user.
                        /readMe already filters revoked, expired, suspended and
                        Switch Role grants; every destination is rechecked by
                        its server endpoint on the next request. */}
                    <AdditionalPageAccess infoSource={infoSource} />

                    {/* ===== Groupe : Switch Role / View As Role (Phase 1) =====
                        Same title style as "Investment"/every other group
                        (.settings-group-title), followed by an always-visible
                        checkbox list -- NOT a dropdown/modal (that behavior is
                        reserved for the desktop Header menu). Visible ONLY to
                        Associate..Family real accounts (isSwitchRoleAvailable) --
                        no group at all for Seller/Provider/Royalty/User, not
                        even an empty title. */}
                    {isSwitchRoleAvailable(infoSource) && (
                        <div className="settings-group role-switch-settings-group">
                            <h5 className="settings-group-title">{elakayAutoText("roleSwitch_settingsGroupTitle", "Switch Role")}</h5>
                            <p className="settings-group-description">
                                {elakayAutoText("roleSwitch_settingsDescription", "Change the active role used for menus and permissions.")}
                            </p>
                            <RoleSwitchDropdown infoSource={infoSource} mode="cards" />
                        </div>
                    )}

                    {/* ===== Groupe : Boutique ===== */}
                    <div className="settings-group">
                        <h5 className="settings-group-title">{infoSource.laguangeElakay('menuSertting', infoSource.languageAPI)?.groupShop || "Boutique"}</h5>
                        <Row xs={2} sm={2} md={3} lg={4} xl={4}>
                            {/* Seller My Shop shortcuts -- not part of an effective Provider's workspace
                                (Provider Center group below instead). */}
                            {!providerOnly && (<>
                            <div className={colClass}>
                                <Link to={"/myshop"}>
                                    <div className="card">
                                        <div className="card-body mx-auto">
                                            <span className="card-title" style={{ fontSize: "50px" }}>
                                                <FaStore />
                                            </span>
                                        </div>
                                        <div className="card-footer text-center" style={styleText}>
                                            {infoSource.laguangeElakay('menuSertting', infoSource.languageAPI).myShop}
                                        </div>
                                    </div>
                                </Link>
                            </div>

                            <div className={colClass}>
                                <Link to={"/myshop?sel=true"}>
                                    <div className="card">
                                        <div className="card-body mx-auto">
                                            <span className="card-title" style={{ fontSize: "50px" }}>
                                                <FaChartLine />
                                            </span>
                                        </div>
                                        <div className="card-footer text-center" style={styleText}>
                                            {infoSource.laguangeElakay('menuSertting', infoSource.languageAPI).sell}
                                        </div>
                                    </div>
                                </Link>
                            </div>

                            <div className={colClass}>
                                <Link to="/myshop?mb=true&BPUB=false">
                                    <div className="card">
                                        <div className="card-body mx-auto">
                                            <span className="card-title" style={{ fontSize: "50px" }}>
                                                <FaGlobe />
                                            </span>
                                        </div>
                                        <div className="card-footer text-center" style={styleText}>
                                            {infoSource.language(infoSource, 'title', 'myShopPub')}
                                        </div>
                                    </div>
                                </Link>
                            </div>

                            <div className={colClass}>
                                <Link to={"/myshop?odr=true"}>
                                    <div className="card">
                                        <div className="card-body mx-auto">
                                            <span className="card-title" style={{ fontSize: "50px" }}>
                                                <MdDashboard />
                                            </span>
                                        </div>
                                        <div className="card-footer text-center" style={styleText}>
                                            {infoSource.laguangeElakay('menuSertting', infoSource.languageAPI).buyerCustomer}
                                        </div>
                                    </div>
                                </Link>
                            </div>

                            <div className={colClass}>
                                <Link to="/myshop?td=true">
                                    <div className="card">
                                        <div className="card-body mx-auto">
                                            <span className="card-title" style={{ fontSize: "50px" }}>
                                                <MdCheckBox />
                                            </span>
                                        </div>
                                        <div className="card-footer text-center" style={styleText}>
                                            {infoSource.laguangeElakay('menuSertting', infoSource.languageAPI).yourProInDeal}
                                        </div>
                                    </div>
                                </Link>
                            </div>

                            <div className={colClass}>
                                <Link to="/myshop?fd=true">
                                    <div className="card">
                                        <div className="card-body mx-auto">
                                            <span className="card-title" style={{ fontSize: "50px" }}>
                                                <MdIndeterminateCheckBox />
                                            </span>
                                        </div>
                                        <div className="card-footer text-center" style={styleText}>
                                            {infoSource.laguangeElakay('menuSertting', infoSource.languageAPI).yourProOutDeal}
                                        </div>
                                    </div>
                                </Link>
                            </div>

                            <div className={colClass}>
                                <Link to="/myshop?trash=1">
                                    <div className="card">
                                        <div className="card-body mx-auto">
                                            <span className="card-title" style={{ fontSize: "50px" }}>
                                                <MdDeleteForever />
                                            </span>
                                        </div>
                                        <div className="card-footer text-center" style={styleText}>
                                            {infoSource.laguangeElakay('menuSertting', infoSource.languageAPI)?.trash || elakayAutoText("h_nav_trash", "Trash")}
                                        </div>
                                    </div>
                                </Link>
                            </div>
                            </>)}

                            <div className={colClass}>
                                <Link to="/delivery">
                                    <div className="card">
                                        <div className="card-body mx-auto">
                                            <span className="card-title" style={{ fontSize: "50px" }}>
                                                <FaTruck />
                                            </span>
                                        </div>
                                        <div className="card-footer text-center" style={styleText}>
                                            {infoSource.laguangeElakay('menuSertting', infoSource.languageAPI)?.delivery || "Centre de livraison"}
                                        </div>
                                    </div>
                                </Link>
                            </div>

                            <div className={colClass}>
                                <Link to="/postman?scan=1">
                                    <div className="card">
                                        <div className="card-body mx-auto">
                                            <span className="card-title" style={{ fontSize: "50px" }}>
                                                <FaRoute />
                                            </span>
                                        </div>
                                        <div className="card-footer text-center" style={styleText}>
                                            {infoSource.laguangeElakay('menuSertting', infoSource.languageAPI)?.postman || "Livreur / Postman"}
                                        </div>
                                    </div>
                                </Link>
                            </div>

                            <div className={colClass}>
                                <Link to="/how-we-do-it">
                                    <div className="card">
                                        <div className="card-body mx-auto">
                                            <span className="card-title" style={{ fontSize: "50px" }}>
                                                <MdPublic />
                                            </span>
                                        </div>
                                        <div className="card-footer text-center" style={styleText}>
                                            {infoSource.laguangeElakay('menuSertting', infoSource.languageAPI)?.howWeDoIt || elakayAutoText("h_hwdi_settings_link", "How We Do It in Elakay")}
                                        </div>
                                    </div>
                                </Link>
                            </div>

                            {(Seller() || Provider()) && (
                                <div className={colClass}>
                                    <div className="card" role="button" onClick={() => setShowLocalSelling(true)}>
                                        <div className="card-body mx-auto">
                                            <span className="card-title" style={{ fontSize: "50px" }}>
                                                <FaMapMarkerAlt />
                                            </span>
                                        </div>
                                        <div className="card-footer text-center" style={styleText}>
                                            {infoSource.laguangeElakay('localSelling', infoSource.languageAPI)?.modalTitle || elakayAutoText("h_9c7e3a1b2d4f56", "Target Location")}
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Email Marketing (spec §3): minimum role is Seller, not Family --
                                server-side permission (assertEmailMarketingPermission) remains the
                                real gate even though this card is Seller-visible by default.
                                Hidden when Email Marketing Settings deny this role access. */}
                            {isCommercialRole && emailMarketing.access.canAccessEmailMarketing && (
                                <div className={colClass}>
                                    <Link to="/elakay/email-marketing-dashboard">
                                        <div className="card">
                                            <div className="card-body mx-auto">
                                                <span className="card-title" style={{ fontSize: "50px" }}>
                                                    <MdMarkEmailRead />
                                                </span>
                                            </div>
                                            <div className="card-footer text-center" style={styleText}>
                                                {infoSource.laguangeElakay('menuSertting', infoSource.languageAPI)?.emailMarketingDashboard || elakayAutoText("h_emk_settings_dashboard_link", "Email Marketing Dashboard")}
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            )}
                        </Row>
                    </div>

                    {/* ===== Groupes Seller : Dropshipping In + External Dropshipping ===== */}
                    {sellerGroups.map((group) => (
                        <div className="settings-group" key={`seller-group-${group.key}`}>
                            <h5 className="settings-group-title">{group.title}</h5>
                            <Row xs={2} sm={2} md={3} lg={4} xl={4}>
                                {group.items.map((item) => {
                                    const Icon = item.icon;
                                    const card = (
                                        <div className="card">
                                            <div className="card-body mx-auto">
                                                <span className="card-title" style={{ fontSize: "50px" }}><Icon /></span>
                                            </div>
                                            <div className="card-footer text-center" style={styleText}>
                                                {item.label}{item.status !== "active" ? ` (${item.statusText})` : ""}
                                            </div>
                                        </div>
                                    );
                                    return (
                                        <div className={colClass} key={`seller-${item.key}`}>
                                            {item.status === "active" ? <Link to={item.route}>{card}</Link> : <div aria-disabled="true">{card}</div>}
                                        </div>
                                    );
                                })}
                            </Row>
                        </div>
                    ))}

                    {/* ===== Groupe : Provider Center ===== (effective Provider, or a combined
                        role with Provider access -- providerWorkspace.js is the single list) */}
                    {providerItems.length > 0 && (
                        <div className="settings-group">
                            <h5 className="settings-group-title">{elakayAutoText("h_pvc_menu_group", "Provider Center")}</h5>
                            <Row xs={2} sm={2} md={3} lg={4} xl={4}>
                                {providerItems.map((item) => {
                                    const Icon = item.icon;
                                    const card = (
                                        <div className="card">
                                            <div className="card-body mx-auto">
                                                <span className="card-title" style={{ fontSize: "50px" }}><Icon /></span>
                                            </div>
                                            <div className="card-footer text-center" style={styleText}>
                                                {item.label}{item.status !== "active" ? ` (${elakayAutoText("h_pvc_soon", "Soon")})` : ""}
                                            </div>
                                        </div>
                                    );
                                    return (
                                        <div className={colClass} key={`provider-${item.key}`}>
                                            {item.status === "active" ? <Link to={item.route}>{card}</Link> : <div aria-disabled="true">{card}</div>}
                                        </div>
                                    );
                                })}
                            </Row>
                        </div>
                    )}

                    {/* ===== Groupe : Investissement ===== */}
                    <div className="settings-group">
                        <h5 className="settings-group-title">{infoSource.laguangeElakay('menuSertting', infoSource.languageAPI)?.groupInvestment || "Investissement"}</h5>
                        <Row xs={2} sm={2} md={3} lg={4} xl={4}>
                            <div className={colClass}>
                                <Link to="/investments">
                                    <div className="card">
                                        <div className="card-body mx-auto">
                                            <span className="card-title" style={{ fontSize: "50px" }}>
                                                <FaMoneyBill />
                                            </span>
                                        </div>
                                        <div className="card-footer text-center" style={styleText}>
                                            {infoSource.laguangeElakay('title', infoSource.languageAPI)?.investment || "Investments"}
                                        </div>
                                    </div>
                                </Link>
                            </div>

                            {isFam && (
                                <div className={colClass}>
                                    <Link to="/elakay/investments-dashboard">
                                        <div className="card">
                                            <div className="card-body mx-auto">
                                                <span className="card-title" style={{ fontSize: "50px" }}>
                                                    <FaMoneyBill />
                                                </span>
                                            </div>
                                            <div className="card-footer text-center" style={styleText}>
                                                {infoSource.laguangeElakay('menuSertting', infoSource.languageAPI)?.investmentDashboard || "Investment Dashboard"}
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            )}
                        </Row>
                    </div>

                    {/* ===== Groupe : Ajouter un rôle ===== */}
                    {showAddRoleGroup && (
                        <div className="settings-group">
                            <h5 className="settings-group-title">{infoSource.laguangeElakay('menuSertting', infoSource.languageAPI)?.groupAddRole || "Ajouter un rôle"}</h5>
                            <Row xs={2} sm={2} md={3} lg={4} xl={4}>
                                {isAssoc && (
                                    <>
                                        <div className={colClass}>
                                            <Link to={"/admin_associat"}>
                                                <div className="card">
                                                    <div className="card-body mx-auto">
                                                        <span className="card-title" style={{ fontSize: "50px" }}>
                                                            <FaUsers />
                                                        </span>
                                                    </div>
                                                    <div className="card-footer text-center" style={styleText}>
                                                        {infoSource.laguangeElakay('menuSertting', infoSource.languageAPI).viewUser}
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>

                                        <div className={colClass}>
                                            <Link to="/admin_associat?page=usersAdd&usel=1">
                                                <div className="card">
                                                    <div className="card-body mx-auto">
                                                        <span className="card-title" style={{ fontSize: "50px" }}>
                                                            <FaCrown />
                                                        </span>
                                                    </div>
                                                    <div className="card-footer text-center" style={styleText}>
                                                        {infoSource.laguangeElakay('menuSertting', infoSource.languageAPI).addUserRoyalty}
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>

                                        <div className={colClass}>
                                            <Link to="/admin_associat?page=usersAdd&usel=2">
                                                <div className="card">
                                                    <div className="card-body mx-auto">
                                                        <span className="card-title" style={{ fontSize: "50px" }}>
                                                            <MdTrendingUp />
                                                        </span>
                                                    </div>
                                                    <div className="card-footer text-center" style={styleText}>
                                                        {infoSource.laguangeElakay('menuSertting', infoSource.languageAPI).addSeller}
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>

                                        <div className={colClass}>
                                            <Link to="/admin_associat?page=usersAdd&usel=3">
                                                <div className="card">
                                                    <div className="card-body mx-auto">
                                                        <span className="card-title" style={{ fontSize: "50px" }}>
                                                            <GiSellCard />
                                                        </span>
                                                    </div>
                                                    <div className="card-footer text-center" style={styleText}>
                                                        {infoSource.laguangeElakay('menuSertting', infoSource.languageAPI).addProducer}
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    </>
                                )}

                                {isInvest && (
                                    <div className={colClass}>
                                        <Link to="/admin_associat?page=usersAdd&usel=4">
                                            <div className="card">
                                                <div className="card-body mx-auto">
                                                    <span className="card-title" style={{ fontSize: "50px" }}>
                                                        <FaHandshake />
                                                    </span>
                                                </div>
                                                <div className="card-footer text-center" style={styleText}>
                                                    {infoSource.laguangeElakay('menuSertting', infoSource.languageAPI).addAssociate}
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                )}

                                {isAdmin && (
                                    <div className={colClass}>
                                        <Link to="/admin_associat?page=usersAdd&usel=5">
                                            <div className="card">
                                                <div className="card-body mx-auto">
                                                    <span className="card-title" style={{ fontSize: "50px" }}>
                                                        <MdAddBusiness />
                                                    </span>
                                                </div>
                                                <div className="card-footer text-center" style={styleText}>
                                                    {infoSource.laguangeElakay('menuSertting', infoSource.languageAPI).addInvestment}
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                )}

                                {isFam && (
                                    <>
                                        <div className={colClass}>
                                            <Link to="/admin_associat?page=usersAdd&usel=6">
                                                <div className="card">
                                                    <div className="card-body mx-auto">
                                                        <span className="card-title" style={{ fontSize: "50px" }}>
                                                            <FaUserCog />
                                                        </span>
                                                    </div>
                                                    <div className="card-footer text-center" style={styleText}>
                                                        {infoSource.laguangeElakay('menuSertting', infoSource.languageAPI).addAdministrator}
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>

                                        <div className={colClass}>
                                            <Link to="/admin_associat?page=usersAdd&usel=7">
                                                <div className="card">
                                                    <div className="card-body mx-auto">
                                                        <span className="card-title" style={{ fontSize: "50px" }}>
                                                            <GiFamilyTree />
                                                        </span>
                                                    </div>
                                                    <div className="card-footer text-center" style={styleText}>
                                                        {infoSource.laguangeElakay('menuSertting', infoSource.languageAPI).addFamilly}
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    </>
                                )}
                            </Row>
                        </div>
                    )}

                    {/* ===== Groupe : Emplois ===== */}
                    {showJobGroup && (
                        <div className="settings-group">
                            <h5 className="settings-group-title">{infoSource.laguangeElakay('menuSertting', infoSource.languageAPI)?.groupJob || "Emplois"}</h5>
                            <Row xs={2} sm={2} md={3} lg={4} xl={4}>
                                {isFam && (
                                    <div className={colClass}>
                                        <Link to="/elakay/job-dashboard">
                                            <div className="card">
                                                <div className="card-body mx-auto">
                                                    <span className="card-title" style={{ fontSize: "50px" }}>
                                                        <FaBriefcase />
                                                    </span>
                                                </div>
                                                <div className="card-footer text-center" style={styleText}>
                                                    {infoSource.laguangeElakay('menuSertting', infoSource.languageAPI)?.jobDashboard || "Job Dashboard"}
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                )}

                                {isAdmin && (
                                    <div className={colClass}>
                                        <Link to="/elakay/job-positions">
                                            <div className="card">
                                                <div className="card-body mx-auto">
                                                    <span className="card-title" style={{ fontSize: "50px" }}>
                                                        <FaBriefcase />
                                                    </span>
                                                </div>
                                                <div className="card-footer text-center" style={styleText}>
                                                    {infoSource.laguangeElakay('menuSertting', infoSource.languageAPI)?.jobPositionsAdmin || "Liste des postes"}
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                )}
                            </Row>
                        </div>
                    )}

                    {/* ===== Groupe : Tableaux de bord et Paramètres ===== */}
                    {showDashboardSettingsGroup && (
                        <div className="settings-group">
                            <h5 className="settings-group-title">{infoSource.laguangeElakay('menuSertting', infoSource.languageAPI)?.groupDashboardSettings || "Tableaux de bord et Paramètres"}</h5>
                            <Row xs={2} sm={2} md={3} lg={4} xl={4}>
                                {isFam && (
                                    <div className={colClass}>
                                        <Link to="/elakay/how-we-do-it-dashboard">
                                            <div className="card">
                                                <div className="card-body mx-auto">
                                                    <span className="card-title" style={{ fontSize: "50px" }}>
                                                        <GrBusinessService />
                                                    </span>
                                                </div>
                                                <div className="card-footer text-center" style={styleText}>
                                                    {infoSource.laguangeElakay('menuSertting', infoSource.languageAPI)?.howWeDoItDashboard || elakayAutoText("h_hwdi_settings_dashboard_link", "How We Do It in Elakay Dashboard")}
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                )}

                                {isFam && (
                                    <div className={colClass}>
                                        <Link to="/elakay-language">
                                            <div className="card">
                                                <div className="card-body mx-auto">
                                                    <span className="card-title" style={{ fontSize: "50px" }}>
                                                        <MdLanguage />
                                                    </span>
                                                </div>
                                                <div className="card-footer text-center" style={styleText}>
                                                    {infoSource.laguangeElakay('menuSertting', infoSource.languageAPI).addLanguage}
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                )}

                                {isFam && (
                                    <>
                                        <div className={colClass}>
                                            <Link to="/traductor-team">
                                                <div className="card">
                                                    <div className="card-body mx-auto">
                                                        <span className="card-title" style={{ fontSize: "50px" }}>
                                                            <FaLanguage />
                                                        </span>
                                                    </div>
                                                    <div className="card-footer text-center" style={styleText}>
                                                        {infoSource.laguangeElakay('menuSertting', infoSource.languageAPI).addTeanTraductor}
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>

                                        <div className={colClass}>
                                            <Link to="/category">
                                                <div className="card">
                                                    <div className="card-body mx-auto">
                                                        <span className="card-title" style={{ fontSize: "50px" }}>
                                                            <MdCreateNewFolder />
                                                        </span>
                                                    </div>
                                                    <div className="card-footer text-center" style={styleText}>
                                                        {infoSource.laguangeElakay('menuSertting', infoSource.languageAPI).creatCatalog}
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>

                                        <div className={colClass}>
                                            <Link to="/filters">
                                                <div className="card">
                                                    <div className="card-body mx-auto">
                                                        <span className="card-title" style={{ fontSize: "50px" }}>
                                                            <FaTools />
                                                        </span>
                                                    </div>
                                                    <div className="card-footer text-center" style={styleText}>
                                                        {infoSource.laguangeElakay('menuSertting', infoSource.languageAPI).creatFilter}
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>

                                        <div className={colClass}>
                                            <Link to="/elakay/Settings">
                                                <div className="card">
                                                    <div className="card-body mx-auto">
                                                        <span className="card-title" style={{ fontSize: "50px" }}>
                                                            <GrSettingsOption />
                                                        </span>
                                                    </div>
                                                    <div className="card-footer text-center" style={styleText}>
                                                        {infoSource.laguangeElakay('menuSertting', infoSource.languageAPI)?.AnimationSettings || elakayAutoText("h_9a51d2cdabc34a", "Font & Animation Settings")}
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>

                                        <div className={colClass}>
                                            <Link to="/elakay/chatbot-dashboard">
                                                <div className="card">
                                                    <div className="card-body mx-auto">
                                                        <span className="card-title" style={{ fontSize: "50px" }}>
                                                            <FaRobot />
                                                        </span>
                                                    </div>
                                                    <div className="card-footer text-center" style={styleText}>
                                                        {infoSource.laguangeElakay('menuSertting', infoSource.languageAPI)?.chatbotDashboard || elakayAutoText("h_7c2f6a1e9b3d44", "Chatbot Dashboard")}
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    </>
                                )}

                                {canOpenSwiperManager && (
                                    <div className={colClass}>
                                        <Link to="/elakay/swipers">
                                            <div className="card">
                                                <div className="card-body mx-auto">
                                                    <span className="card-title" style={{ fontSize: "50px" }}>
                                                        <FaImages />
                                                    </span>
                                                </div>
                                                <div className="card-footer text-center" style={styleText}>
                                                    {infoSource.laguangeElakay('menuSertting', infoSource.languageAPI)?.swiperManager || elakayAutoText("h_dsw_manager_title", "Swiper Manager")}
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                )}

                                {isAdmin && (
                                    <div className={colClass}>
                                        <Link to="/pageBuilder">
                                            <div className="card">
                                                <div className="card-body mx-auto">
                                                    <span className="card-title" style={{ fontSize: "50px" }}>
                                                        <GrSettingsOption />
                                                    </span>
                                                </div>
                                                <div className="card-footer text-center" style={styleText}>
                                                    {infoSource.laguangeElakay('menuSertting', infoSource.languageAPI)?.pageBuilder || elakayAutoText("h_f29aa6896ad555", "Page Studio")}
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                )}
                            </Row>
                        </div>
                    )}

                    {/* ===== Groupe : Finance (Family only) ===== */}
                    {isFam && (
                        <div className="settings-group">
                            <h5 className="settings-group-title">{infoSource.laguangeElakay('menuSertting', infoSource.languageAPI)?.groupFinance || elakayAutoText("h_tc_menu_group", "Finance")}</h5>
                            <Row xs={2} sm={2} md={3} lg={4} xl={4}>
                                <div className={colClass}>
                                    <Link to="/elakay/transaction-center">
                                        <div className="card">
                                            <div className="card-body mx-auto">
                                                <span className="card-title" style={{ fontSize: "50px" }}>
                                                    <FaExchangeAlt />
                                                </span>
                                            </div>
                                            <div className="card-footer text-center" style={styleText}>
                                                {infoSource.laguangeElakay('menuSertting', infoSource.languageAPI)?.transactionCenter || elakayAutoText("h_tc_menu_link", "Transaction Center")}
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            </Row>
                        </div>
                    )}

                    {/* ===== Groupe : Système ===== */}
                    {isFam && (
                        <div className="settings-group">
                            <h5 className="settings-group-title">{infoSource.laguangeElakay('menuSertting', infoSource.languageAPI)?.groupSystem || "Système"}</h5>
                            <Row xs={2} sm={2} md={3} lg={4} xl={4}>
                                <div className={colClass}>
                                    <Link to="/elakay/system-health">
                                        <div className="card">
                                            <div className="card-body mx-auto">
                                                <span className="card-title" style={{ fontSize: "50px" }}>
                                                    <FaHeartbeat />
                                                </span>
                                            </div>
                                            <div className="card-footer text-center" style={styleText}>
                                                {infoSource.laguangeElakay('menuSertting', infoSource.languageAPI)?.systemHealth || "System Health"}
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            </Row>
                        </div>
                    )}

                    {/* ===== Groupe : Sécurité ===== */}
                    {isFam && (
                        <div className="settings-group">
                            <h5 className="settings-group-title">{infoSource.laguangeElakay('menuSertting', infoSource.languageAPI)?.groupSecurity || "Sécurité"}</h5>
                            <Row xs={2} sm={2} md={3} lg={4} xl={4}>
                                <div className={colClass}>
                                    <Link to="/elakay/security-center">
                                        <div className="card">
                                            <div className="card-body mx-auto">
                                                <span className="card-title" style={{ fontSize: "50px" }}>
                                                    <FaShieldAlt />
                                                </span>
                                            </div>
                                            <div className="card-footer text-center" style={styleText}>
                                                {infoSource.laguangeElakay('menuSertting', infoSource.languageAPI)?.securityCenter || "Security Center"}
                                            </div>
                                        </div>
                                    </Link>
                                </div>

                                <div className={colClass}>
                                    <Link to="/elakay/Settings/monitoring">
                                        <div className="card">
                                            <div className="card-body mx-auto">
                                                <span className="card-title" style={{ fontSize: "50px" }}>
                                                    <MdSecurity />
                                                </span>
                                            </div>
                                            <div className="card-footer text-center" style={styleText}>
                                                {infoSource.laguangeElakay('menuSertting', infoSource.languageAPI)?.monitoringSettings || "Monitoring & Security Settings"}
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            </Row>
                        </div>
                    )}

                    {/* ===== Permission Center (owner / real Family role, even under Switch Role) ===== */}
                    {canSeePermissionCenterLink(infoSource) && (
                        <div className="settings-group">
                            <h5 className="settings-group-title">{elakayAutoText("h_perm_title", "Elakay Permission Center")}</h5>
                            <Row xs={2} sm={2} md={3} lg={4} xl={4}>
                                <div className={colClass}>
                                    <Link to="/elakay/permission-center">
                                        <div className="card">
                                            <div className="card-body mx-auto">
                                                <span className="card-title" style={{ fontSize: "50px" }}>
                                                    <FaUserShield />
                                                </span>
                                            </div>
                                            <div className="card-footer text-center" style={styleText}>
                                                {elakayAutoText("h_perm_title", "Elakay Permission Center")}
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            </Row>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );

    return (
        <Layout
            infoSource={infoSource}
            title={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).userSerting.t001}
            description={elakayAutoText("h_41682905073222", "Node React E-commerce App")}
            className="container-fluid"
            SliderPunShow={false}
            loading={false}
            {...infoSource?.allSettings?.layout}
        >
            <WeeklyIncomePreference infoSource={infoSource} />
            <div style={infoSource.styleNav}>
                {infoUser}
                {menu}
            </div>
            {(Seller() || Provider()) && (
                <LocalSellingModal
                    showModal={showLocalSelling}
                    setShowModal={setShowLocalSelling}
                    infoSource={infoSource}
                    token={token}
                />
            )}
        </Layout>
    );
};

export default UserSerting;
